import { ClusterOutlined } from '@ant-design/icons';
import { NavItemType } from 'types/menu';

const icons = {
  ClusterOutlined
};

// ==============================|| MENU ITEMS - FORMS & TABLES ||============================== //

const templates: NavItemType = {
  id: 'group-templates',
  title: 'Templates',
  icon: icons.ClusterOutlined,
  type: 'group',
  children: [
    {
      id: 'templates',
      title: 'Templates',
      type: 'collapse',
      icon: icons.ClusterOutlined,
      children: [
        {
          id: 'services',
          title: 'Services',
          type: 'item',
          url: '/templates/services'
        },
        {
          id: 'emails',
          title: 'Status Notifications',
          type: 'item',
          url: '/templates/emails'
        },
        {
          id: 'talent-access-blast',
          title: 'Talent Access Blast',
          type: 'item',
          url: '/templates/talent-access-blasts'
        },
        {
          id: 'terms',
          title: 'Terms',
          type: 'item',
          url: '/templates/terms'
        },
        {
          id: 'talent-costs',
          title: 'Talent Costs',
          type: 'item',
          url: '/templates/talent-costs'
        }
      ]
    }
  ]
};

export default templates;
